export default "/assets/images/chart-05.svg?8d3c7564830651db36a1dd27d5ea36cc";